import { Link } from "react-router-dom";
import { hasPermission } from "../api/adminClient";
import { ROUTES } from "./routes";

export default function AdminConsoleTabs({ active }) {
  const tabs = [
    { key: "users", label: "Admin Users", to: ROUTES.adminUsers, show: hasPermission("admin:manage_users") },
    { key: "roles", label: "Roles & Permissions", to: ROUTES.adminRoles, show: hasPermission("admin:manage_roles") },
    { key: "ops", label: "Admin access", to: ROUTES.adminAccess, show: hasPermission("admin:manage_users") },
  ].filter((t) => t.show);
  if (tabs.length < 2) return null;
  return (
    <div className="mb-6 flex w-fit max-w-full flex-wrap items-center gap-1.5 rounded-2xl border border-slate-200/80 bg-slate-100 p-1.5 shadow-[inset_0_2px_5px_rgba(15,23,42,0.07)] dark:border-slate-700/70 dark:bg-slate-800/70">
      {tabs.map((t) => (
        <Link
          key={t.key}
          to={t.to}
          aria-current={active === t.key ? "page" : undefined}
          className={`rounded-xl px-4 py-2 text-sm font-semibold transition-all ${
            active === t.key
              ? "bg-white text-[#004f73] shadow-[inset_0_1px_0_rgba(255,255,255,0.9),0_1px_3px_rgba(0,79,115,0.18)] dark:bg-slate-900 dark:text-[#7fd4e3]"
              : "text-slate-500 hover:bg-white/60 hover:text-slate-700 dark:text-slate-400 dark:hover:bg-slate-900/50 dark:hover:text-slate-200"
          }`}
        >
          {t.label}
        </Link>
      ))}
    </div>
  );
}
